export const EMPTY_ARRAY = [] as const;
export const EMPTY_OBJECT = {} as const;
